export default __webpack_public_path__ + "static/media/bg-header.e76ab334.svg";